export default __webpack_public_path__ + "static/media/investorSteveJobs.b916e2ad.mp3";